module.exports = __webpack_public_path__ + "img/DSC_2708.259b42a1.png";